import { api } from "@/api/axios.ts";
import {
  ApiProductAnnouncement,
  ApiProductAnnouncementEventType,
} from "@/types/product-announcement.types.ts";

export const apiProductAnnouncements = {
  getCurrent: (signal: AbortSignal) => {
    return api.get<ApiProductAnnouncement | null>(
      `/api/v1/product-announcements/current`,
      {},
      signal,
      // Бэкенд без этой ручки отвечает 404: блок не рендерится, тоста быть не должно
      { skipNotFoundToast: true }
    );
  },
  registerEvent: (id: number, eventType: ApiProductAnnouncementEventType) => {
    return api.post(`/api/v1/product-announcements/${id}/events`, { event_type: eventType });
  },
};
